import React from "react";
import "./css/bootstrap.css";
import "./css/style.css";
import "./css/responsive.css";
import RouteList from "./routes";
import { Provider } from "react-redux";
import store from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import "../src/pages/home/css/FloatingButton.css";
let persistor = persistStore(store);
function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <RouteList />
      </PersistGate>
    </Provider>
  );
}

export default App;
